import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { environment } from "src/environments/environment.development"
import { ConfigAService } from './services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Dispatch_UI';
  constructor(
    private http: HttpClient,private conf: ConfigAService
  ) {
    // this.conf.getBaseURL();
  }
  // getBaseURL() {
  //   console.log(environment.basePath);
  //   this.http.get('assets/api_config.json').subscribe(res => {
  //     console.log("df", res);
  //     environment.basePath = res['basePath'];
  //     environment.basePort = res['basePort'];
  //     environment.baseReportPath = res['baseReportPath'];
  //     environment.baseReportPort = res['baseReportPort'];
  //     // urlForTeacher= 'https://gnn.shikshadaily.com/Teacher/';
  //     // urlForStudent ='https://gnn.shikshadaily.com/Student/';
  //   })
  //   setTimeout((ele: any) => {
  //     console.log(environment.basePath);
  //   }, 200)
  // }
}
